export type HealthStatusColor = "success" | "error" | "warning" | "default";

/** Title-case a raw status/probe token for display, e.g. "unhealthy" -> "Unhealthy", "assume_role" -> "Assume role". */
export function formatHealthToken(token: string): string {
  if (!token) {
    return "";
  }
  const spaced = token.replace(/_/g, " ");
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}

export function healthStatusColor(status: string): HealthStatusColor {
  switch (status) {
    case "healthy":
      return "success";
    case "unhealthy":
      return "error";
    case "unknown":
      return "warning";
    case "unverified":
    default:
      return "default";
  }
}

/** Canonical order the probes run in, so the dialog lists them in a stable, meaningful sequence. */
export const PROBE_ORDER = [
  "assume_role",
  "location",
  "list",
  "put",
  "get",
  "delete",
] as const;
